import React from 'react';
import { LineBar } from './styles';

const GenericLineBar: React.FC<any> = ({ ...props }) => {
  return <LineBar {...props} />;
};

export default GenericLineBar;
